export const releaseNotesRoutes = [
  {
    path: '/release-notes',
    name: 'ReleaseNotes',
    component: () => import('@/modules/release-notes/containers/release-notes.container.vue'),
    meta: {
      requiresAuth: false,
      layout: 'newAuth',
      module: 'release-notes',
    },
  },
]

export default releaseNotesRoutes
